module.exports = __webpack_public_path__ + "img/ShoppingCart.9db1d402.svg";